import { i18n } from '../lib';
import { AvailableLocaleCodes, MultiLangText } from './locale';

export interface Region {
	id?: number;
	code: string;
	name: MultiLangText;
	districts?: District[];
}

export interface District {
	id?: number;
	code: string;
	name: MultiLangText;
	region?: Region;
	regionCode: string;
	subDistricts?: SubDistrict[];
}

export interface SubDistrict {
	code: string;
	name: MultiLangText;
	district?: District;
	districtCode: string;
}

export const RegionOptionAllCode = '_ALL';
export const OutsideHongKongCode = '_OUTSIDEHK';
export const DistrictOptionAllCode = '_ALL';
export const SubDistrictOptionAllCode = '_ALL';

export const regionOptionAllFactory = (): Pick<Region, 'name' | 'code'> => ({
	name: [...AvailableLocaleCodes]
		.map(localeCode => [
			localeCode,
			i18n
				.t('dialogs.location.address.options.allRegion', localeCode)
				.toString(),
		])
		.reduce(
			(result, [localeCode, text]) => ({ ...result, [localeCode]: text }),
			{},
		),
	code: RegionOptionAllCode,
});

export const outsideHongKongFactory = (): Pick<Region, 'name' | 'code'> => ({
	name: [...AvailableLocaleCodes]
		.map(localeCode => [
			localeCode,
			i18n
				.t('dialogs.location.address.options.outsideHongKong', localeCode)
				.toString(),
		])
		.reduce(
			(result, [localeCode, text]) => ({ ...result, [localeCode]: text }),
			{},
		),
	code: OutsideHongKongCode,
});

export const districtOptionAllFactory = (): Pick<
	District,
	'name' | 'code'
> => ({
	name: [...AvailableLocaleCodes]
		.map(localeCode => [
			localeCode,
			i18n
				.t('dialogs.location.address.options.allDistrict', localeCode)
				.toString(),
		])
		.reduce(
			(result, [localeCode, text]) => ({ ...result, [localeCode]: text }),
			{},
		),
	code: DistrictOptionAllCode,
});

export const subDistrictOptionAllFactory = (): Pick<
	SubDistrict,
	'name' | 'code'
> => ({
	name: [...AvailableLocaleCodes]
		.map(localeCode => [
			localeCode,
			i18n
				.t('dialogs.location.address.options.allSubDistrict', localeCode)
				.toString(),
		])
		.reduce(
			(result, [localeCode, text]) => ({ ...result, [localeCode]: text }),
			{},
		),
	code: SubDistrictOptionAllCode,
});
